<template>
  <v-container fluid mb-4>
    <v-row justify="center">
      <v-col cols="12" md="6">
        <v-card tile max-width="500">
          <v-toolbar :dark="$vuetify.theme.dark" color="primary">
            <v-toolbar-title>
              {{ $t('Условия поставки') }}
            </v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-list>
              <v-list-item
                  v-for="(item, ind) in items"
                  :key="ind"
                  link
                  @click="goToRoute(item.route)">
                <v-list-item-icon>
                  <v-icon v-text="item.icon" />
                </v-list-item-icon>
                <v-list-item-content class="text-left">
                  <v-list-item-title v-text="item.name" />
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    computed: {
      items () {
        return [{
                  name: this.$t('Условия и базис поставки Incoterms'),
                  route: `${this.urlRootPath}/incoterms`,
                  icon: 'mdi-truck'
                },
                {
                  name: this.$t('Размер предоплаты'),
                  route: `${this.urlRootPath}/prepayments`,
                  icon: 'mdi-cog-outline'
                }]
      }
    }
  }
</script>
